import { MODULE_GRID } from "../data/balance.js";
import type { CellOffset } from "../data/moduleFootprints.js";

export interface CellCenter {
  readonly cx: number;
  readonly cy: number;
}

export interface FootprintBox {
  readonly centerX: number;
  readonly centerY: number;
  readonly rectW: number;
  readonly rectH: number;
}

export function gridCellKey(gridWidth: number, x: number, y: number): number {
  // Start/Fire는 그리드 밖 x=-1 또는 x=width일 수 있어 +1 offset으로 in-bounds와 충돌을 피한다.
  return (y + 1) * (gridWidth + 2) + (x + 1);
}

export function gridPathCellSet(gridWidth: number, cells: readonly { x: number; y: number }[]): Set<number> {
  const set = new Set<number>();
  for (const c of cells) set.add(gridCellKey(gridWidth, c.x, c.y));
  return set;
}

export function computeFootprintBox(
  x: number,
  y: number,
  cells: readonly CellOffset[],
  cellCenter: (x: number, y: number) => CellCenter,
  step: number,
): FootprintBox {
  let minDx = Infinity;
  let maxDx = -Infinity;
  let minDy = Infinity;
  let maxDy = -Infinity;
  for (const c of cells) {
    if (c.dx < minDx) minDx = c.dx;
    if (c.dx > maxDx) maxDx = c.dx;
    if (c.dy < minDy) minDy = c.dy;
    if (c.dy > maxDy) maxDy = c.dy;
  }
  const tl = cellCenter(x + minDx, y + minDy);
  const br = cellCenter(x + maxDx, y + maxDy);
  const spanCols = maxDx - minDx + 1;
  const spanRows = maxDy - minDy + 1;
  return {
    centerX: (tl.cx + br.cx) / 2,
    centerY: (tl.cy + br.cy) / 2,
    rectW: spanCols * step - MODULE_GRID.cellGap - 2,
    rectH: spanRows * step - MODULE_GRID.cellGap - 2,
  };
}
